import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState, AdminUser, ExchangeOffice } from '../../types';

const ADMIN_TOKEN_KEY = process.env.REACT_APP_ADMIN_TOKEN_KEY || 'admin-token';
const OFFICE_TOKEN_KEY = process.env.REACT_APP_OFFICE_TOKEN_KEY || 'office-token';

const initialState: AuthState = {
  isAuthenticated: false,
  userType: null,
  adminUser: null,
  officeUser: null,
  currentOffice: null,
  token: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // Admin login
    adminLogin: (state, action: PayloadAction<{ user: AdminUser; token: string }>) => {
      state.isAuthenticated = true;
      state.userType = 'admin';
      state.adminUser = action.payload.user;
      state.officeUser = null;
      state.currentOffice = null;
      state.token = action.payload.token;
      localStorage.setItem(ADMIN_TOKEN_KEY, action.payload.token);
      localStorage.setItem('admin-user', JSON.stringify(action.payload.user));
      localStorage.setItem('user-type', 'admin');
    },
    
    // Office login
    officeLogin: (state, action: PayloadAction<{ office: ExchangeOffice; token: string }>) => {
      state.isAuthenticated = true;
      state.userType = 'office';
      state.adminUser = null;
      state.officeUser = {
        id: action.payload.office.id,
        name: action.payload.office.name,
        accountUsername: action.payload.office.accountUsername,
        role: 'office',
      };
      state.currentOffice = action.payload.office;
      state.token = action.payload.token;
      localStorage.setItem(OFFICE_TOKEN_KEY, action.payload.token);
      localStorage.setItem('office-user', JSON.stringify(action.payload.office));
      localStorage.setItem('user-type', 'office');
    },
    
    // Logout (handles both admin and office)
    logout: (state) => {
      const userType = state.userType;
      state.isAuthenticated = false;
      state.userType = null;
      state.adminUser = null;
      state.officeUser = null;
      state.currentOffice = null;
      state.token = null;
      
      if (userType === 'admin') {
        localStorage.removeItem(ADMIN_TOKEN_KEY);
        localStorage.removeItem('admin-user');
      } else {
        localStorage.removeItem(OFFICE_TOKEN_KEY);
        localStorage.removeItem('office-user');
      }
      localStorage.removeItem('user-type');
    },
    
    // Initialize auth state from localStorage
    initializeAuth: (state) => {
      const userType = localStorage.getItem('user-type');
      
      if (userType === 'admin') {
        const token = localStorage.getItem(ADMIN_TOKEN_KEY);
        const userStr = localStorage.getItem('admin-user');
        if (token && userStr) {
          state.isAuthenticated = true;
          state.userType = 'admin';
          state.token = token;
          state.adminUser = JSON.parse(userStr);
        }
      } else if (userType === 'office') {
        const token = localStorage.getItem(OFFICE_TOKEN_KEY);
        const officeStr = localStorage.getItem('office-user');
        if (token && officeStr) {
          const office = JSON.parse(officeStr);
          state.isAuthenticated = true;
          state.userType = 'office';
          state.token = token;
          state.officeUser = {
            id: office.id,
            name: office.name,
            accountUsername: office.accountUsername,
            role: 'office',
          };
          state.currentOffice = office;
        }
      }
    },
    
    
  },
});

export const { 
  adminLogin, 
  officeLogin, 
  logout, 
  initializeAuth,
   
} = authSlice.actions;
export default authSlice.reducer;
